import { createAction } from "@reduxjs/toolkit";
import { SLICE_NAME } from "./Slice";
export const doSearchAction = createAction(`${SLICE_NAME}/doSearchAction`);
export const getBrandsAsyncAction = createAction(`${SLICE_NAME}/brandAsyncAction`);
export const getTestBrandsAsyncAction = createAction(`${SLICE_NAME}/testBrandAsyncAction`);
export const getBrandSettingsAsyncAction = createAction(`${SLICE_NAME}/getBrandSetting`);
